"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BANDWIDTH_ESTIMATION_HYBRID_CONFIG_1 = require("./Constants/BANDWIDTH_ESTIMATION_HYBRID_CONFIG");
var BandwidthEstimateType_1 = require("./Constants/BandwidthEstimateType");
var HttpRequestClose_1 = require("./Constants/HttpRequestClose");
var BandwidthEstimationHybrid = /** @class */ (function () {
    function BandwidthEstimationHybrid(shaka) {
        this.history = [];
        this.segments = {};
        this.bandwidthEstimate = BANDWIDTH_ESTIMATION_HYBRID_CONFIG_1.default.defaultBandwidthEstimate;
        this.useNetworkEstimateForInterval = false;
        this.numActiveSegments = 0;
        this.received = 0;
        this.shaka = shaka;
        this.lastUpdateTime = Date.now();
    }
    BandwidthEstimationHybrid.prototype.onHttpRequestOpen = function (id, requestType) {
        var shaka = this.shaka;
        if (shaka.net.NetworkingEngine.RequestType.SEGMENT === requestType) {
            this.segments[id] = {
                startTime: Date.now(),
                load: 0,
                hasReceivedFirstByte: false
            };
        }
    };
    BandwidthEstimationHybrid.prototype.onHttpRequestProgress = function (id, load, _ /*total*/) {
        if (!(id in this.segments)) {
            return;
        }
        var segment = this.segments[id];
        var delta = load - segment.load;
        segment.load = load;
        this.received += delta;
    };
    BandwidthEstimationHybrid.prototype.onHttpRequestFirstByte = function (id) {
        if (!(id in this.segments)) {
            return;
        }
        this.segments[id].hasReceivedFirstByte = true;
        this.numActiveSegments += 1;
    };
    BandwidthEstimationHybrid.prototype.onHttpRequestClose = function (id, reason) {
        if (!(id in this.segments)) {
            return;
        }
        var _a = this.segments[id], startTime = _a.startTime, load = _a.load, hasReceivedFirstByte = _a.hasReceivedFirstByte;
        if (reason === HttpRequestClose_1.default.Load) {
            if (load >= BANDWIDTH_ESTIMATION_HYBRID_CONFIG_1.default.minLoad) {
                var finishTime = Date.now();
                var duration = Math.max(BANDWIDTH_ESTIMATION_HYBRID_CONFIG_1.default.minDuration, finishTime - startTime);
                var bandwidthEstimate = (load * 8000) / duration;
                this.addBandwidthEstimate(bandwidthEstimate, BandwidthEstimateType_1.default.SIMPLE);
            }
        }
        if (hasReceivedFirstByte) {
            this.numActiveSegments -= 1;
            if (this.numActiveSegments === 0) {
                this.useNetworkEstimateForInterval = false;
            }
        }
        delete this.segments[id];
    };
    BandwidthEstimationHybrid.prototype.getBandwidthEstimate = function () {
        return this.bandwidthEstimate;
    };
    BandwidthEstimationHybrid.prototype.updateBandwidthEstimate = function () {
        var now = Date.now();
        if (this.useNetworkEstimateForInterval) {
            var elapsed = now - this.lastUpdateTime;
            var bandwidthEstimate = (8 * 1000 * this.received) / elapsed;
            this.addBandwidthEstimate(bandwidthEstimate, BandwidthEstimateType_1.default.NETWORK);
        }
        if (this.history.length > 0) {
            var sum = this.history.reduce(function (total, value) { return total + value; }, 0);
            var average = sum / this.history.length;
            this.bandwidthEstimate = average;
        }
        this.received = 0;
        this.lastUpdateTime = now;
        this.useNetworkEstimateForInterval = (this.numActiveSegments > 0);
    };
    BandwidthEstimationHybrid.prototype.setBandwidthEstimate = function (bandwidthEstimate) {
        this.history = [bandwidthEstimate];
        this.bandwidthEstimate = bandwidthEstimate;
    };
    BandwidthEstimationHybrid.prototype.addBandwidthEstimate = function (bandwidthEstimate, _ /*type*/) {
        this.history.push(bandwidthEstimate);
        if (this.history.length > BANDWIDTH_ESTIMATION_HYBRID_CONFIG_1.default.historySize) {
            this.history = this.history.slice(-BANDWIDTH_ESTIMATION_HYBRID_CONFIG_1.default.historySize);
        }
    };
    return BandwidthEstimationHybrid;
}());
exports.default = BandwidthEstimationHybrid;
//# sourceMappingURL=BandwidthEstimationHybrid.js.map